/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

export const orgUserGroup = {
  header: 'Todos los grupos de usuarios ({{count}})',
  disabled: '(deshabilitado)',
  uid: 'Código',
  name: 'Nombre',
  unit: 'Unidad',
  orgUnit: 'Unidad',
  actions: '',

  sortBy: 'Ordenar por',
  sort: {
    byName: 'Nombre',
    byUnitName: 'Unidad',
    byGroupID: 'Grupo',
  },

  hint: 'Los grupos de usuarios le permiten combinar usuarios en un solo grupo, con el fin de asignar límites de compra para muchos usuarios a la vez.',

  details: {
    title: 'Detalles del grupo de usuarios',
    subtitle: 'Grupo de usuarios: {{ item.name }}',
  },

  edit: {
    title: 'Editar grupo de usuarios',
    subtitle: 'Grupo de usuarios: {{ item.name }}',
  },

  create: {
    title: 'Crear grupo de usuarios',
    subtitle: '',
  },

  links: {
    user: 'Usuarios',
    permission: 'Límites de compra',
  },

  messages: {
    update: 'Usuario Grupo {{ item.name }} actualizado con éxito',
    create: 'Usuario Grupo {{ item.name }} creado con éxito',
    deleteTitle: 'Delete this user group?',
    delete:
      'Los usuarios de este grupo no se ven afectados cuando se elimina el grupo de usuarios.',
    deleted: 'Usuario Grupo {{ item.name }} eliminado con éxito',
  },

  breadcrumbs: {
    list: 'Todos los grupos de usuarios',
    details: '{{name}}',
    users: 'Usuarios',
    permissions: 'Límites de compra',
  },
};

export const orgUserGroupAssignedUsers = {
  title: 'Usuarios asignados',
  subtitle: 'Grupo de usuarios: {{ item.name }}',
  assigned: 'Usuario {{item.name}} asignado correctamente',
  unassigned: 'Usuario {{item.name}} desasignado correctamente',
};

export const orgUserGroupUsers = {
  title: 'Administrar usuarios',
  subtitle: 'Grupo de usuarios: {{ item.name }}',
  assigned: 'Usuario {{item.name}} asignado correctamente',
  unassigned: 'Usuario {{item.name}} desasignado correctamente',
  unassignAll: 'Anular la asignación de todo',
  unassignAllConfirmation: 'Todos los usuarios no asignados correctamente',
};
export const orgUserGroupAssignedPermissions = {
  title: 'Límites de compra asignados',
  subtitle: 'Límite: {{ item.name }}',
  assigned: 'Límites de compra {{item.code}} asignados con éxito',
  unassigned: 'Límites de compra {{item.code}} unassigned successfully',
};

export const orgUserGroupPermissions = {
  title: 'Gestionar los límites de compra',
  subtitle: 'Límite: {{ item.name }}',
  assigned: 'Límites de compra {{item.code}} asignados con éxito',
  unassigned: 'Límites de compra {{item.code}} unassigned successfully',
};
